import { faArrowRight, faCheckCircle, faEye, faEyeSlash, faXmark, faSpinner, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { SERVER_URL } from '../../config';
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from "react-router-dom";
import CountryList from '../../country.json'
import Select from 'react-select';
import GoogleTranslate from '../../GoogleTranslate';
import '../Styles/App.css';

export default function PlayerSignup() {

    const footballPositions = [
        { value: "Goalkeeper", label: "Goalkeeper" },
        { value: "Defender", label: "Defender" },
        { value: "Midfielder", label: "Midfielder" },
        { value: "Forward", label: "Forward" },
    ];

    const [fullname, setFullname] = useState('');
    const [dob, setdob] = useState('');
    const [nationality, setNationality] = useState('');
    const [preferredPosition, setPreferredPosition] = useState('');
    const [feet, setFeet] = useState('');
    const [inches, setInches] = useState('');
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [nftValue, setNftValue] = useState('');
    const [email, setEmail] = useState('');
    const [token, settoken] = useState(null);
    const [tokenValid, setTokenValid] = useState(false);
    const [searchParams] = useSearchParams();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otp, setOtp] = useState('');

    const [otpPopUp, setOtpPopUp] = useState(false);
    const [resendTimer, setResendTimer] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    const [errors, setErrors] = useState({});

    const [isSendingOTP, setIsSendingOTP] = useState(false);
    const [isVerifyingOTP, setIsVerifyingOTP] = useState(false);
    const [isResendingOTP, setIsResendingOTP] = useState(false);

    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (isResendDisabled) {
            const timer = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev === 1) {
                        clearInterval(timer);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [isResendDisabled]);

    const handleResendOTP = async () => {
        setIsResendingOTP(true);
        setIsResendDisabled(true);
        setResendTimer(60);
        await handleSendOTP();
        setIsResendingOTP(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword((prev) => !prev);
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    const passwordsMatch = password === confirmPassword && password !== '';

    const handleSubmit = async () => {
        console.log("In handleSubmit");
        try {
            const playerData = {
                fullname: fullname?.trim(),
                dob: dob?.trim(),
                nationality: nationality?.trim(),
                preferred_position: preferredPosition?.trim(),
                height: height?.toString().trim(),
                weight: weight?.toString().trim(),
                email: email?.trim(),
                password: password?.trim(),
                token: token?.trim(),
                nftValue: nftValue?.trim()
            }
            console.log("Player Data :", playerData);
            const response = await axios.post(`${SERVER_URL}/api/v2/player-signup`, playerData);
            console.log("Response from server:", response);
            if (response.status === 201) {
                toast.success("Registered successfully!");
                setTimeout(() => {
                    navigate("/player/login");
                }, 3000);
            }
        } catch (error) {
    console.error("Signup error object:", error);
    const message = error?.response?.data?.msg || error?.message || "Failed to register player. Please try again.";
    toast.error(message);
}

    };

    const handlePreSignup = async () => {
        try {

            const playerData = {
                fullname: fullname.trim(),
                dob: dob.trim(),
                nationality: nationality.trim(),
                weight: weight.trim(),
                preferred_position: preferredPosition.trim(),
                height: height.toString().trim(),
                password: password.trim(),
                token: token.trim(),
                nftValue: nftValue.trim()
            }

            const response = await axios.post(`${SERVER_URL}/api/v2/complete-signup`, playerData);

            if (response.status === 201) {
                toast.success("Registered successfully!");
                setTimeout(() => {
                    navigate("/player/login");
                }, 3000);
            }
        } catch (error) {
            console.error("Error during Signup : ", error);
            toast.error(`${error?.response?.data?.msg}` || "Failed to register player. Please try again.");
        }
    };

    const handleSendOTP = async () => {
        let data = {
            "Full name": fullname.trim(),
            "DOB": dob.trim(),
            "Nationality": nationality.trim(),
            "Preferred Position": preferredPosition.trim(),
            "Height": height.toString().trim(),
            "weight": weight.toString().trim(),
            "Email": email.trim(),
            "Password": password.trim()
        };

        const newErrors = {};
        if (!fullname.trim()) {
            newErrors.fullname = "Name is required";
        } else {
            const nameRegex = /^[A-Za-z\s]{2,}$/;
            const onlyWhitespace = /^\s+$/;
            const hasNumbers = /\d/;
            if (onlyWhitespace.test(fullname)) {
                newErrors.fullname = "Name cannot be only whitespace";
            } else if (hasNumbers.test(fullname)) {
                newErrors.fullname = "Name cannot contain numbers";
            } else if (!nameRegex.test(fullname)) {
                newErrors.fullname = "Name must be at least 2 characters";
            }
        }

        if (!dob.trim()) {
            newErrors.dob = "Date of birth is required";
        } else {
            const dobRegex = /^\d{4}-\d{2}-\d{2}$/;
            const enteredDate = new Date(dob);
            const today = new Date();
            if (!dobRegex.test(dob)) {
                newErrors.dob = "DOB must be in YYYY-MM-DD format";
            } else if (enteredDate > today) {
                newErrors.dob = "Date of birth cannot be in the future";
            }
        }

        if (!nationality.trim()) newErrors.nationality = "Please select your nationality";
        if (!weight.trim()) newErrors.weight = "Weight (kg) is required";
        if (!preferredPosition.trim()) newErrors.preferredPosition = "Please select your position";
        if (!feet) newErrors.height = "Height (feet) is required";
        if (!nftValue) newErrors.nftValue = "NFT value is required";

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email.trim())) newErrors.email = "Invalid email format";
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else {
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
            if (!passwordRegex.test(password)) {
                newErrors.password = "Password must be at least 8 characters, with uppercase, lowercase, numbers and special character";
            }
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = "Please confirm your password";
        } else if (password && confirmPassword && password !== confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        if (tokenValid) {
            handlePreSignup();
            return;
        }
        setErrors({});
        setIsSendingOTP(true);

        const playerData = {
            fullname: fullname.trim(),
            dob: dob.trim(),
            nationality: nationality.trim(),
            weight: weight.trim(),
            preferred_position: preferredPosition.trim(),
            height: height.toString().trim(),
            email: email.trim(),
            password: password.trim()
        }

        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/register-otp`, { email: email.trim(), role: "players" });
            if (response.data.status) {
                toast.success("OTP sent to your email!");
                setOtpPopUp(true);
            } else {
                toast.error(response.data.msg || "Failed to send OTP.");
            }
        } catch (error) {
            console.error("Error sending OTP. Try again :", error);
            toast.error(error ? error?.response?.data?.msg : "Error sending OTP. Try again.");
        } finally {
            setIsSendingOTP(false);
        }
    };

    const handleVerifyOTP = async () => {
        if (!otp) {
            toast.error("Please enter the OTP.");
            return;
        }
        setIsVerifyingOTP(true);
        try {
            const response = await axios.post(`${SERVER_URL}/api/v2/verify-otp`, { email: email.trim(), otp, role: "players" });
            if (response.data.status) {
                toast.success("OTP verified successfully!");
                handleSubmit()
            } else {
                toast.error("Incorrect OTP. Try again.");
            }
        } catch (error) {
            console.error("Error during verifying otp : ", error);
            toast.error(`${error?.response?.data?.msg}`);
        } finally {
            setIsVerifyingOTP(false);
        }
    };

    useEffect(() => {
        if (feet !== '' && inches !== '') {
            const totalHeight = parseFloat(feet) + (parseFloat(inches) / 10);
            setHeight(totalHeight.toFixed(1));
        }
    }, [feet, inches]);

    useEffect(() => {
        const updatedErrors = { ...errors };

        if (fullname && errors.fullname) delete updatedErrors.fullname;
        if (dob && errors.dob) delete updatedErrors.dob;
        if (nationality && errors.nationality) delete updatedErrors.nationality;
        if (preferredPosition && errors.preferredPosition) delete updatedErrors.preferredPosition;
        if (feet && errors.height) delete updatedErrors.height;
        // if (email && errors.email) delete updatedErrors.email;
        // if (password && errors.password) delete updatedErrors.password;
        // if (confirmPassword && errors.confirmPassword && password === confirmPassword) delete updatedErrors.confirmPassword;
        if (nftValue && nftValue.error) delete updatedErrors.nftValue;
        if (Object.keys(updatedErrors).length !== Object.keys(errors).length) {
            setErrors(updatedErrors);
        }
    }, [fullname, dob, nationality, preferredPosition, nftValue, feet, inches, nftValue]);

    useEffect(() => {
        const jwtToken = searchParams.get('token');
        if (jwtToken) {
            try {
                const decoded = jwtDecode(jwtToken);
                console.log("decoded :", decoded)
                if (decoded?.email) {
                    setEmail(decoded.email);
                    settoken(jwtToken)
                    setTokenValid(true);
                }

            } catch (err) {
                console.error('Invalid token:', err);
                setTokenValid(false);
            }
        }
    }, [searchParams]);

    const isMobileDevice = () => {
        return /Mobi|Android|iPhone/i.test(navigator.userAgent);
    };

    useEffect(() => {
        setIsMobile(isMobileDevice());
    }, []);
    
    const isValidWeight = (value) => {
    if (value === '') return true;
    const floatRegex = /^\d*\.?\d{0,2}$/;
    return floatRegex.test(value) && parseFloat(value) <= 300;
    };

    return (
        <div className='min-h-screen flex flex-col items-center justify-center bg-cover py-10 overflow-hidden' style={{ backgroundImage: 'url("/assets/bg/Authbg.svg")' }}>
            <div className='flex justify-between w-full md:mb-0 mb-10'>
                <div className='w-[50%]'>
                    <button onClick={() => { window.location.href = '/' }} className=" cursor-pointer absolute top-5 left-5 flex items-center gap-2 text-white px-4 py-2 rounded-full">
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span >Back</span>
                    </button>
                </div>

                <div className='top-5 right-1 absolute'>
                    <GoogleTranslate />

                </div>
            </div>
            <div className='w-[90%] flex flex-col-reverse lg:flex-row items-center gap-10 text-white '>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <img src='/assets/others/herosignup.svg' className='md:w-[80%] mx-auto' data-aos='fade-right' data-aos-duration='1500'></img>
                    <img src='/assets/others/Ball.svg' className='ball-spin w-[25%] absolute bottom-10 right-0 lg:hidden block' style={{ zIndex: 1 }} />
                </div>
                <div className='w-[100%] lg:w-[50%] relative'>
                    <div className='bg-white/5 lg:w-[90%] 2xl:w-[80%] 2xl:mx-auto p-7 lg:px-10 py-10 lg:py-5 2xl:py-10  fade-up-slide' >
                        <h1 className='text-center text-3xl md:text-5xl 2xl:text-6xl' style={{ fontFamily: 'Sacramento' }}>Sign up</h1>
                        <div className='w-[100%] md:w-[90%] mx-auto mt-4 2xl:mt-5 space-y-2 2xl:space-y-3'>

                            <input
                                placeholder='Name'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[a-zA-Z]*$/.test(value)) {
                                        setFullname(value);
                                    }
                                }}
                                value={fullname}
                                className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                            />
                            {errors.fullname && <p className="text-red-400 text-sm">{errors.fullname}</p>}

                            <div className='relative w-[100%]'>
                                <input
                                    type='date'
                                    max={new Date().toISOString().split("T")[0]}
                                    placeholder='Date of Birth'
                                    onChange={(e) => { setdob(e.target.value) }}
                                    value={dob}
                                    className={`w-[100%]  ${isMobile && !dob ? 'text-transparent mb-3' : 'bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'}`}
                                />
                                {errors.dob && <p className="text-red-400 text-sm">{errors.dob}</p>}

                                {isMobile && !dob && (
                                    <span className="absolute rounded bg-[#545454]/20 w-full left-0 top-0 py-1.5 px-3 text-white font-semibold pointer-events-none">
                                        Date of Birth
                                    </span>
                                )}
                            </div>

                            <select
                                className="w-full font-semibold bg-[#54545420] text-white rounded-md py-3 px-3 outline-none border border-transparent focus:border-white transition-all duration-200"
                                value={nationality}
                                onChange={(e) => setNationality(e.target.value)}
                            >
                                <option className="bg-black text-white" value="">
                                    Select a country
                                </option>
                                {CountryList.map((country, index) => (
                                    <option
                                        key={country.label}
                                        className="bg-black text-white"
                                        value={country.label}
                                    >
                                        {country.label} {country.country_flag}
                                    </option>
                                ))}
                            </select>
                            {errors.nationality && <p className="text-red-400 text-sm">{errors.nationality}</p>}

                            <select
                                className="w-full font-semibold bg-[#54545420] text-white rounded-md py-3 px-3 outline-none border border-transparent focus:border-white transition-all duration-200"
                                value={preferredPosition}
                                onChange={(e) => setPreferredPosition(e.target.value)}
                            >
                                <option className="bg-black text-white" value="">
                                    Select Preferred Position
                                </option>
                                {footballPositions.map((position, index) => (
                                    <option
                                        key={position.label}
                                        className="bg-black text-white"
                                        value={position.label}
                                    >
                                        {position.label}
                                    </option>
                                ))}
                            </select>
                            {errors.preferredPosition && <p className="text-red-400 text-sm">{errors.preferredPosition}</p>}

                            <div className="flex gap-3">
                                <select
                                    className="w-[50%] font-semibold bg-[#54545420] text-white rounded-md py-2 px-3 outline-none border border-transparent focus:border-white transition-all duration-200"
                                    value={feet}
                                    onChange={(e) => setFeet(e.target.value)}
                                >
                                    <option value="">Height in Feet</option>
                                    {[...Array(10)].map((_, i) => {
                                        const ft = i + 1;
                                        return (
                                            <option key={ft} value={ft} className="bg-black text-white">
                                                {ft} ft
                                            </option>
                                        );
                                    })}
                                </select>

                                <select
                                    className="w-[50%] font-semibold bg-[#54545420] text-white rounded-md py-2 px-3 outline-none border border-transparent focus:border-white transition-all duration-200"
                                    value={inches}
                                    onChange={(e) => setInches(e.target.value)}
                                >
                                    <option value="">Height in Inch</option>
                                    {[...Array(11)].map((_, i) => (
                                        <option key={i} value={i} className="bg-black text-white">
                                            {i} in
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {errors.height && <p className="text-red-400 text-sm">{errors.height}</p>}
                            <input
                                placeholder="Weight in kg"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (isValidWeight(value)) {
                                        setWeight(value);
                                        setErrors((prev) => ({ ...prev, weight: '' })); 
                                    }
                                }}
                                value={weight}
                                className="w-full bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3"
                            />


                            {errors.weight && <p className="text-red-400 text-sm">{errors.weight}</p>}

                            <input
                                placeholder='NFT value in dollars'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === '' || (/^[0-9]*\.?[0-9]*$/.test(value) && Number(value) <= 1_000_000_000_000)) {
                                        setNftValue(value);
                                    }
                                }}
                                value={nftValue}
                                className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                            />
                            {errors.nftValue && <p className="text-red-400 text-sm">{errors.nftValue}</p>}

                            <input
                                type="email"
                                name="fake_email_"  // A non-standard name to confuse autocomplete
                                autoComplete="off"
                                placeholder="Email Address"
                                disabled={tokenValid}
                                value={email}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setEmail(value);

                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    setErrors((prev) => ({
                                        ...prev,
                                        email: value && !emailRegex.test(value.trim())
                                            ? "Invalid email format"
                                            : "",
                                    }));
                                }}
                                className="w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3"
                            />
                            {errors.email && <p className="text-red-400 text-sm">{errors.email}</p>}

                            <div className='relative'>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder='Create Password'
                                    value={password}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setPassword(value);

                                        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
                                        setErrors((prev) => ({
                                            ...prev,
                                            password: value && !passwordRegex.test(value)
                                                ? "Password must be at least 8 characters with uppercase, lowercase, number & special character"
                                                : "",
                                        }));
                                    }}
                                    className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                                />

                                <button
                                    type='button'
                                    onClick={togglePasswordVisibility}
                                    className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                                >
                                    <FontAwesomeIcon
                                        icon={showPassword ? faEye : faEyeSlash}
                                        className='text-gray-500'
                                    />
                                </button>
                            </div>
                            {errors.password && <p className="text-red-400 text-sm">{errors.password}</p>}

                            <div className='relative'>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    placeholder='Confirm Password'
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setConfirmPassword(value);

                                        setErrors((prev) => ({
                                            ...prev,
                                            confirmPassword:
                                                value && password && value !== password
                                                    ? "Passwords do not match"
                                                    : "",
                                        }));
                                    }}
                                    className='w-[100%] bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3'
                                />

                                <button type='button' onClick={toggleConfirmPassword} className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'>
                                    <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} className='text-gray-500' />
                                </button>
                                {passwordsMatch && (
                                    <div className='absolute right-10 top-1/2 transform -translate-y-1/2'>
                                        <FontAwesomeIcon icon={faCheckCircle} className='text-green-500' />
                                    </div>
                                )}
                            </div>
                            {errors.confirmPassword && <p className="text-red-400 text-sm">{errors.confirmPassword}</p>}

                        </div>
                        <div className='flex justify-center mt-4 2xl:mt-5'>
                            <button onClick={handleSendOTP} className='border rounded-full flex items-center gap-2 py-[2px] pl-5 pr-[2px] cursor-pointer' disabled={isSendingOTP}>
                                <span>{isSendingOTP ? 'Sending OTP...' : 'Sign up'}</span>
                                <button className='w-8 h-8 rounded-full bg-white text-black grid place-content-center'>
                                    {isSendingOTP ? (
                                        <FontAwesomeIcon icon={faSpinner} spin />
                                    ) : (
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    )}
                                </button>
                            </button>

                        </div>
                        {/* <p className='font-semibold text-center mt-4 2xl:mt-5'>Need Help With Login ? Support</p> */}
                        <p className="font-semibold text-center mt-5">
                            <span onClick={() => navigate("/player/login")} className=" cursor-pointer hover:underline">
                                Already have account
                            </span>
                        </p>
                    </div>
                    <div data-aos='fade-right' data-aos-duration='1500'>
                        <img src='/assets/others/Ball.svg' className='ball-spin absolute -bottom-7 right-7 hidden lg:block' style={{ zIndex: 1 }} />
                    </div>
                </div>
            </div>
            {otpPopUp && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm z-50">
                    <div className="bg-white/15 w-[90%] lg:w-[30%] p-7 lg:px-10 py-10 lg:py-5 2xl:py-10 text-white rounded-lg shadow-lg relative" data-aos="fade-down" data-aos-duration="1500">
                        <button onClick={() => setOtpPopUp(false)} className="absolute cursor-pointer top-3 right-3 text-white text-xl">✕</button>

                        <h1 className="text-center text-3xl md:text-5xl 2xl:text-6xl" style={{ fontFamily: "Sacramento" }}>
                            Verify Email
                        </h1>
                        <div className="w-[100%] md:w-[90%] mx-auto mt-4 2xl:mt-5 space-y-2 2xl:space-y-3">
                            <input
                                placeholder="Enter the OTP"
                                onChange={(e) => setOtp(e.target.value)}
                                className="w-full bg-[#545454]/20 placeholder:text-white placeholder:font-semibold rounded outline-none py-2 px-3"
                            />
                        </div>

                        <div className="flex justify-center mt-4 2xl:mt-5 gap-5">
                            <button onClick={handleResendOTP} disabled={isResendDisabled || isResendingOTP} className={`border rounded-full px-5 py-2 ${isResendDisabled || isResendingOTP ? "opacity-50 cursor-not-allowed" : ""}`}>
                                {isResendingOTP ? "Resending..." : `Resend ${resendTimer > 0 ? `(${resendTimer}s)` : ""}`}
                            </button>

                            <button onClick={handleVerifyOTP} className='bg-white text-black rounded-md px-5 py-2' disabled={isVerifyingOTP}>
                                {isVerifyingOTP ? "Verifying..." : "Verify"}
                            </button>
                        </div>
                    </div>
                </div >
            )}
        </div >
    )
}
